import React from 'react';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';
import ConnectedFormattedImage from 'Containers/ConnectedFormattedImage';

import styles from './AppFeature.scss';

const AppFeature = ({ app }) => {
  const { slug, graphicFileName, iconFileName } = app;

  let graphicUri;
  try {
    graphicUri = require(`./${graphicFileName}`);
  } catch (e) {
    graphicUri = '';
  }

  let iconUri;
  try {
    iconUri = require(`./${iconFileName}`);
  } catch (e) {
    iconUri = '';
  }

  return (
    <div className={`AppFeature AppFeature--${slug}`}>
      <div className="AppFeature__container">
        <div className="AppFeature__subject">
          <ConnectedFormattedMessage id={`model.${slug}.subject`} />
        </div>
        <ConnectedFormattedImage
          className="AppFeature__graphic"
          src={graphicUri}
          altId={`model.${slug}.graphicAlt`}
        />
        <ConnectedFormattedImage
          className="AppFeature__icon"
          src={iconUri}
          altId={`model.${slug}.iconAlt`}
        />
        <h3 className="AppFeature__title">
          <ConnectedFormattedMessage id={`model.${slug}.title`} />
        </h3>
        <p className="AppFeature__description">
          <ConnectedFormattedMessage id={`model.${slug}.description`} />
        </p>
      </div>
    </div>
  );
};

export default AppFeature;
